/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from "react"
import { HasId, ID } from "src/libs/interfaces/layouts"
import IScalarForm from "src/libs/scalars/interface/IScalarForm"
import CalloutNoExists from "src/libs/useful/CalloutNoExists"
import { __, sprintf } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { LANDING_SCALAR } from "../data/landin_scalars"
import { schema } from "../data/schema"
import createMeat from "../views/landing/landing-edit/utils/createMeat"
import { AddBtn } from "./composite/AddBtn"
import AnimatedDelayScalar from "./composite/AnimatedDelayScalar"
import AnimationTypeScalar from "./composite/AnimationTypeScalar"
import CardScalar from "./composite/CardScalar"
import CardsOrderScalar from "./composite/CardsOrderScalar"
import CompositionScalar from "./composite/CompositionScalar"
import DataContentScalar from "./composite/DataContentScalar"
import DotNavigationScalar from "./composite/DotNavigationScalar"
import FieldInputScalar from "./composite/FieldInputScalar"
import LandingCompositeDefault from "./composite/LandingCompositeDefault"
import LandingCompositeFeed from "./composite/LandingCompositeFeed"
import MarriageItemScalar from "./composite/MariageItemScalar"
import ProportionScalar from "./composite/ProportionScalar"
import ScreenPositionScalar from "./composite/ScreenPositionScalar"
import TypographyScalar from "./composite/TypographyScalar"
import VKVideoScalar from "./composite/VKVideoScalar"
import HeaderElementOrderScalar from "./composite/HeaderElementOrderScalar" 
import FloatScalar from "./composite/FloatScalar"
import PositionScalar from "./composite/PositionScalar"
import CategoryIdScalar from "./composite/CategoryIdScalar"
import OverlayScalar from "./composite/OverlayScalar"
import CanvasScalar from "./composite/CanvasScalar"
import LandingComponentIdScalar from "./composite/LandingComponentIdScalar"
import RatingScalar from "./composite/RatingScalar"
import ExternalLinksFeedScalar from "./composite/ExternalLinksFeedScalar"

/* Protopia Ecosystem component */
export interface ICompositeWidgetProps {
    dataSection: string
    field?: string
    dataName: string
    title?: string
    subtitle?: string
    type: string
    component?: string
    value: any // TODO: не обновляется с обновлением исходных данных!!!
    default?: any
    length? : number
    isNotCard?: boolean
    isDefaultOpen?: boolean
    isAlwaysOpen?: boolean
    editable?: boolean
    isDeleted?: boolean
    presetLib?:string
    onChange?: ( value: any, file: any, name: string ) => void
    onRemove?: ( item: HasId ) => void
    origin?: any // full value of owner object (fex. "Section" )
    visualization?: string 
    subMenus?: IScalarForm[]
    onSubmenu?: () => void
    sectionId?: ID
    commentary?: string
    kind?: string | "type" | "sections" | LANDING_SCALAR.CATEGORY 
}
const LandingCompositeWidget = (props: ICompositeWidgetProps): JSX.Element => { 
    // console.log(props.type)
    switch( props.type ) {
        case LANDING_SCALAR.COMPOSITION:
            return <CompositionScalar { ...props } editable />
        case LANDING_SCALAR.PROPORTION:
            return <ProportionScalar { ...props } editable columns={3} />
        case LANDING_SCALAR.ANIMATED_DELAY:
            return <AnimatedDelayScalar { ...props } editable />
        case LANDING_SCALAR.ANIMATED:
            return <AnimationTypeScalar 
                { ...props } 
                editable 
                value={{
                    animated: props.origin?.animated,
                    animated_delay: props.origin?.animated_delay,
                }}
                onChange={
                    ( val: any, field: string, data: any ) => {
                        if( props.onChange ) {
                            props.onChange( val, field, data )
                        }
                    }
                }
            />
        case LANDING_SCALAR.DOT_NAVIGATION:
            return <DotNavigationScalar {...props} editable />
        case LANDING_SCALAR.VK_VIDEO:
            return <VKVideoScalar {...props} editable />
        case LANDING_SCALAR.CARD:
            return <CardScalar {...props} editable />
        case LANDING_SCALAR.CARD_ORDER:
            return <CardsOrderScalar {...props} editable />
        case LANDING_SCALAR.MARRIAGE_ITEM: 
            return <MarriageItemScalar {...props} editable />
        case LANDING_SCALAR.CONTENT:
            return <DataContentScalar {...props} editable />
        case LANDING_SCALAR.TYPOGRAPHY: 
            return <TypographyScalar {...props} editable />
        case LANDING_SCALAR.SCREEN_PLACE: 
            return <ScreenPositionScalar  {...props} columns={10} editable />
        case LANDING_SCALAR.FIELD_INPUT: 
            return <FieldInputScalar {...props} editable />
        case LANDING_SCALAR.HEADER_ORDER: 
            return <HeaderElementOrderScalar {...props} editable />
        case LANDING_SCALAR.FLOATS:
            return <FloatScalar {...props} editable />
        case LANDING_SCALAR.CATEGORY_ID:
            return <CategoryIdScalar {...props} editable />
        case LANDING_SCALAR.LANDING_MEMBER_ID: 
            return <LandingComponentIdScalar {...props} editable />
        case "Position":
            return <PositionScalar {...props} editable />
        case LANDING_SCALAR.CANVAS:
            return <CanvasScalar {...props} editable />
        case LANDING_SCALAR.RATING:
            return <RatingScalar {...props} editable />
        case LANDING_SCALAR.EXTERNAL_LINK_FEED:
            return <ExternalLinksFeedScalar {...props} editable />
        case LANDING_SCALAR.MODAL:
            if( props.kind !== "type") {
                return <OverlayScalar {...props} editable />
            } 
            else {
                return <LandingComposite {...props} editable /> 
            }
        default:
            return <LandingComposite {...props} editable /> 
    }
}

const LandingComposite = (props: ICompositeWidgetProps): JSX.Element => {
    const schemaType = useMemo(() => [ "edited_array", "external_array" ].includes( props.type )
        ?
        schema()[ props.component || "Section" ]?.apollo_fields  || ""
        :
        schema()[ props.type ].apollo_fields, 
    [props.type, props.component])
    const value = useSyncState<any>( props.value )
    useEffect(() => {
        value.set( props.value )
    }, [ props.value ])

    const onChange = ( _value: any, field: string="", data: any="", type:string="" ) => {

        // TODO:: костыль!!!
        if([ "smart_background" ].includes( props.dataName )) { 
            //console.log(_value, field, data, type )
            _value = {...value.get(), [ field ]: _value}
        }

        value.set(_value) 
        if(props.onChange) {
            props.onChange( 
                _value, 
                props.dataName,
                ""
            )
        }
    } 
    const onAdd = ( type: string, n:number, field: string = "field" ) => {
        const newVal = [ ...value.get(), createMeat(type, n, {}) ]
        value.set( newVal )
        if( props.onChange ) { 
            props.onChange( 
                newVal, 
                props.dataSection,
                ""
            )
        }
    } 
    if( !schemaType ) {
        return  <CalloutNoExists message={sprintf( __(`Unknown data type — %s (%s)`), props.dataSection, props.type)} />
    }
    if([ "edited_array", "external_array" ].includes( props.type ) ) {
        return Array.isArray(props.value) && !!props.value.length
            ?
            <LandingCompositeFeed
                title={props.title || props.subtitle}
                subMenus={props.subMenus}
                onSubmenu={props.onSubmenu}
                origin={props.origin}
                component={ props.component }
                isAlwaysOpen={ props.isAlwaysOpen }
                schemaType={schemaType}
                value={value.get() as any[]}
                isDeleted={ props.isDeleted }
                dataName={props.dataName}
                dataSection={props.dataSection}
                onChange={onChange}
                onValue={(_val: any) => {                    
                    console.log( _val )                    
                    value.set(_val )
                }}  
            /> 
            :
            <>
                <CalloutNoExists />
                <div className="container">
                    <AddBtn onAdd={ onAdd }  component={ props.component || "" }/>
                </div>
            </>
    }

    return <LandingCompositeDefault 
        {...props}  
        value={value.get()} 
        isAlwaysOpen={ typeof props.isAlwaysOpen !== "undefined" ? props.isAlwaysOpen : true }
        origin={ props.origin ? props.origin[ props.dataName ] : {} }
        dataName={props.dataName}
        dataSection={props.dataSection}
        onChange={ ( value: any, field: string, data: any ) => onChange( value, field, data, value.id ) }
    /> 
       
}
export default LandingCompositeWidget